import React from "react";

const Skipped = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6154 4V12M10.4738 8.53169L4.92554 11.768C4.83202 11.8226 4.72575 11.8515 4.61747 11.8519C4.50919 11.8522 4.40274 11.824 4.30885 11.7701C4.21496 11.7162 4.13696 11.6384 4.08273 11.5447C4.02851 11.451 3.99997 11.3446 4 11.2363V4.76369C3.99997 4.65541 4.02851 4.54904 4.08273 4.45532C4.13696 4.3616 4.21496 4.28384 4.30885 4.22991C4.40274 4.17597 4.50919 4.14776 4.61747 4.14813C4.72575 4.1485 4.83202 4.17743 4.92554 4.232L10.4732 7.46892C10.5661 7.52314 10.6431 7.60073 10.6966 7.69396C10.7501 7.78719 10.7782 7.89281 10.7782 8.00031C10.7782 8.10781 10.7501 8.21343 10.6966 8.30666C10.6431 8.39989 10.5667 8.47748 10.4738 8.53169Z"
        stroke="#666666"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Skipped;
